import api from "./api";

// Matches WalletController exactly. Note GetUserWallet's odd behaviour:
// on first call for a user with no wallet yet, it creates one server-side
// but still returns 404 for that call — so a 404 here isn't necessarily
// an error, just means "check again" or treat balance as zero for now.
export const getUserWallet = async (userId) => {
  try {
    const res = await api.get(`/wallet/user/${userId}`);
    return res.data?.data ?? null;
  } catch (err) {
    if (err.response?.status === 404) return null;
    throw err;
  }
};

export const getWalletTransactions = async (walletId) => {
  const res = await api.get(`/wallet/transactions/${walletId}`);
  const data = res.data?.data;
  return data?.$values ?? data ?? [];
};
